// extracted by mini-css-extract-plugin
export default {"RsPriceRadioGroup":"priceRadio_RsPriceRadioGroup__yfnhQ"};